import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import f, { createContext as m, useContext as D, useMemo as l, useState as P } from "react";
import { useId as T } from "../../hooks/use-id.js";
import { forwardRefWithAs as g, render as x } from "../../utils/render.js";
import { useIsoMorphicEffect as E } from "../../hooks/use-iso-morphic-effect.js";
import { useSyncRefs as h } from "../../hooks/use-sync-refs.js";
import { useEvent as v } from "../../hooks/use-event.js";
var d = m(null);

function u() {
  var r = D(d);

  if (r === null) {
    var t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, u), t;
  }

  return r;
}

function k() {
  var _P = P([]),
      _P2 = _slicedToArray(_P, 2),
      r = _P2[0],
      t = _P2[1];

  return [r.length > 0 ? r.join(" ") : void 0, l(function () {
    return function (e) {
      var i = v(function (n) {
        return t(function (o) {
          return [].concat(_toConsumableArray(o), [n]);
        }), function () {
          return t(function (o) {
            var c = o.slice(),
                p = c.indexOf(n);
            return p !== -1 && c.splice(p, 1), c;
          });
        };
      }),
          s = l(function () {
        return {
          register: i,
          slot: e.slot,
          name: e.name,
          props: e.props
        };
      }, [i, e.slot, e.name, e.props]);
      return f.createElement(d.Provider, {
        value: s
      }, e.children);
    };
  }, [t])];
}

var S = "p",
    F = g(function (t, a) {
  var e = u(),
      i = "headlessui-description-".concat(T()),
      s = h(a);
  E(function () {
    return e.register(i);
  }, [i, e.register]);

  var n = t,
      o = _objectSpread(_objectSpread({
    ref: s
  }, e.props), {}, {
    id: i
  });

  return x({
    ourProps: o,
    theirProps: n,
    slot: e.slot || {},
    defaultTag: S,
    name: e.name || "Description"
  });
});
export { F as Description, k as useDescriptions };